import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';

export default function BasicDateCalendar({ updateField, selectedDates }) {
    const [date, setDate] = useState(selectedDates ? dayjs(selectedDates) : null);

    useEffect(() => {
        if (selectedDates) {
            setDate(dayjs(selectedDates));
        }
    }, [selectedDates]);

    const handleDateChange = (newDate) => {
        setDate(newDate);
        updateField("exp_date", newDate ? newDate : null);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer sx={{ paddingBottom: 1 }} components={['DatePicker']}>
                <DatePicker
                    value={date}
                    size="small"
                    fullWidth
                    updateField
                    onChange={handleDateChange}
                    label="Ημερομηνία τιμολογίου"
                    format="DD-MM-YYYY"
                    sx={{
                        width: '100%',
                        height: 'auto',
                        '& .MuiInputBase-root': {
                            height: 40,
                        },
                        '& .MuiInputLabel-root': {
                            fontSize: '0.975rem',
                            top: '-6px',
                        },
                        '& .MuiInputLabel-shrink': {
                            top: 0,
                        },
                    }}
                />
            </DemoContainer>
        </LocalizationProvider>
    );
}
